//
// the controller for the search users page
//
usersModule.controller('UsersSearchController',
    ['$scope', 'SearchFilters', 'usersSearchService', 'User', 'usersMgEvents','TLCError','AppErrorCodes','growl',
    function ($scope, SearchFilters, usersSearchService, User, usersMgEvents, TLCError,AppErrorCodes,growl) {
        $scope.users = [];
        $scope.totalItems = 0;
        $scope.currentPageSize = 0;
        $scope.currentPage = 0;
        $scope.currentSortType = 'lastName';
        $scope.currentSortOrder = 'asc';

        // filters
        $scope.filters = new SearchFilters();

        init();

        function init() {
            $scope.currentPageSize = 20;
            $scope.currentPage = 0;
        }

        $scope.onSearch = function() {
            if ($scope.filters.firstName == '' && $scope.filters.lastName == '' && $scope.filters.loginID == '')
                growl.warning('Please enter at least one search term');
            else {
                $scope.currentPage = 0;
                $scope.users = [];
                refresh();
            }
        };

        $scope.onSelectUser = function(user) {
            $scope.$broadcast(usersMgEvents.searchUserSelected, user);
        };

        //When a user gets updated, instead of doing a search, we update that user's info in memory
        $scope.$on(usersMgEvents.userUpdated, function(event, userToUpdate) {
            //Looking for user to update in memory
            _.each($scope.users, function(user){
                if (user.id == userToUpdate.id) {
                    angular.copy(userToUpdate, user);
                }
            });
        });

        function refresh() {
            $scope.busy = true;

            usersSearchService.searchUsers($scope.currentPage, $scope.currentPageSize, $scope.currentSortType, $scope.currentSortOrder, $scope.filters)
            .then(function(users){
                $scope.users = $scope.users.concat(users);
            }, function(err) {
                throw new TLCError(new Error(err),AppErrorCodes.UserSearchController_GeneralError);
            }).finally(function() {
                $scope.busy = false;
            });
        }

        $scope.clearFiltersandResults = function(){
            $scope.filters = null;
            $scope.users = [];
        };

    }
]);